import { render, staticRenderFns } from "./ProductModelShow.vue?vue&type=template&id=78d98f36&"
import script from "./ProductModelShow.vue?vue&type=script&lang=js&"
export * from "./ProductModelShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports